<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header"
               class="card-header"><i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>部门</div>
          <div style="overflow:auto;height: calc(100vh - 179px);">
            <es-org-tree @clickByOrg="loadPlanLineList"
                         @completed="initOrgTree"></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card class="card">
          <div slot="header"
               class="card-header"><i class="el-icon-font el-icon-quyu el-icon--left"></i>巡检线路计划</div>
          <div class="es-op-box">

            <el-input placeholder="请输入线路名称"
                      v-model="queryObj.lineName"
                      size="small"
                      class="query"
                      style="float: left"
                      clearable
                      @change="() => { this.queryObj.pageNum = 1; loadPlanLineList(selectorgId) }">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-select style="float: left;"
                       class="query"
                       size="small"
                       v-model="queryObj.states"
                       placeholder="请选择状态"
                       clearable
                       filterable
                       @clear="() => {
                this.queryObj.states = null
              }"
                       @change="() => { this.queryObj.pageNum = 1; loadPlanLineList() }">
              <el-option v-for="item in statesArr"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
            <el-select style="float: left;"
                       class="query"
                       size="small"
                       v-model="queryObj.stateInspeopleId"
                       placeholder="请选是否分配"
                       clearable
                       filterable
                       @clear="() => {
                this.queryObj.stateInspeopleId = null
              }"
                       @change="() => { this.queryObj.pageNum = 1; loadPlanLineList() }">
              <el-option v-for="item in stateInspeopleArr"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
            <el-date-picker style="float: left;width:230px"
                            format="yyyy-MM-dd"
                            v-model="dateTime"
                            type="daterange"
                            size="small"
                            range-separator="至"
                            start-placeholder="计划开始"
                            end-placeholder="计划结束"
                            @change="() => { this.queryObj.pageNum = 1; loadPlanLineList(selectorgId) }">
            </el-date-picker>

            <el-button type="primary"
                       icon="el-icon-font  el-icon-ziyuanldpi"
                       size="mini"
                       style="margin-right:6px"
                       @click="createplan()">生成计划</el-button>
            <es-delete @del="deleteLineplan()"
                       type="button"></es-delete>
          </div>
          <el-table :data="pageData.list"
                    ref="lineTable"
                    border
                    stripe
                    size="mini"
                    height="calc(100vh - 250px)"
                    v-loading="loading">
            <el-table-column type="selection"
                             width="40"
                             align="center">
            </el-table-column>
            <el-table-column type="index"
                             label="序号"
                             width="50"
                             align="center">
            </el-table-column>
            <!-- <el-table-column prop="plandate" label="生成时间">
              <template slot-scope="scope">
                {{ scope.row.plandate.substring(0, 10) }}
              </template>
            </el-table-column> -->
            <el-table-column prop="lineName"
                             label="巡检线路名称">
            </el-table-column>
            <el-table-column prop="starttime"
                             label="开始时间">
            </el-table-column>
            <el-table-column prop="endtime"
                             label="结束时间">
            </el-table-column>
            <el-table-column prop="inspeopleName"
                             label="巡检人员">
            </el-table-column>
            <el-table-column prop="companionName"
                             label="协作人">
            </el-table-column>
            <el-table-column prop="inscount"
                             label="完成/总数"
                             align="center"
                             width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.finishCount == null">0/{{ scope.row.totalCount }}</span>
                <span v-else> {{ scope.row.finishCount }}/{{ scope.row.totalCount }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="finishTime"
                             label="最后执行时间">
            </el-table-column>
            <el-table-column prop="states"
                             width="70"
                             label="是否分配"
                             align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.inspeopleId != null && scope.row.inspeopleId != ''"
                        size="mini"
                        type="success">已分配</el-tag>
                <el-tag v-else
                        size="mini"
                        type="warning">未分配</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="states"
                             width="70"
                             label="状态"
                             align="center">
              <template slot-scope="scope">
                <el-tag size="mini"
                        :type="showState(scope.row)">{{ scope.row.statename }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="faultcode"
                             label="故障状态"
                             width="70"
                             align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.faultCode == null || scope.row.faultCode == ''"
                        slot="reference"
                        size="mini"
                        type="success">正常</el-tag>

                <el-popover v-else
                            placement="top">
                  <p>&nbsp;&nbsp;故障编码</p>
                  <div style="text-align: center; margin: 10">
                    <el-link v-for="(item, index) in scope.row.faultCodelist "
                             :key="index"
                             @click="viewFaultInfo(item)"
                             icon="el-icon-warning"
                             type="danger">{{ item }}&nbsp;</el-link>
                    <br />
                    <br />
                  </div>
                  <el-tag slot="reference"
                          size="mini"
                          type="danger">故障</el-tag>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="操作"
                             width="100"
                             align="center">
              <template slot-scope="scope">
                <el-link v-if="!(scope.row.state == null || scope.row.state == 0)"
                         :underline="false"
                         disabled
                         title="指派巡检人"
                         type="primary"><i class="el-icon-user-solid"></i></el-link>
                <el-link v-else
                         :underline="false"
                         title="指派巡检人"
                         @click="distribute(scope.row)"
                         type="primary"><i class="el-icon-user-solid"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link :underline="false"
                         title="详情"
                         @click="showDevicePlan(scope.row)"
                         type="primary"><i class="el-icon-notebook-2"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <es-delete v-if="!(scope.row.state == null || scope.row.state == 0)"
                           disabled
                           type="icon"></es-delete>
                <es-delete v-else
                           @del="deleteLineplan(scope.row.id)"
                           :key="scope.row.id"
                           type="icon"></es-delete>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData"
                           @change="(cpage) => { this.queryObj.pageNum = cpage; this.loadPlanLineList() }">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!--查看线路管理详情-->
    <el-dialog :visible.sync="detailVisible"
               @closed="() => this.$refs['detailForm'].clearValidate()"
               width="800px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>查看巡检计划详情
      </span>
      <el-form :model="lineInfo"
               size="mini"
               label-position="right"
               label-width="600px"
               ref="detailForm">
        <div class="es-op-box">
          <el-input placeholder="区域名称"
                    v-model="queryDetailObj.areaName"
                    size="small"
                    class="query"
                    style="float: left"
                    clearable
                    @change="() => { this.queryDetailObj.pageNum = 1; loadDevicePlan() }">
            <i slot="suffix"
               class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-input placeholder="设备名称"
                    v-model="queryDetailObj.deviceName"
                    size="small"
                    class="query"
                    style="float: left"
                    clearable
                    @change="() => { this.queryDetailObj.pageNum = 1; loadDevicePlan() }">
            <i slot="suffix"
               class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-select style="float: left;"
                     class="query"
                     size="small"
                     v-model="queryDetailObj.states"
                     placeholder="请选择状态"
                     clearable
                     filterable
                     @clear="() => {
              this.queryDetailObj.states = null
            }"
                     @change="() => { this.queryDetailObj.pageNum = 1; loadDevicePlan() }">
            <el-option v-for="item in statesDetailArr"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </div>
        <br />
        <br />

        <el-table style="margin-top: 10px;"
                  :data="devicePlanPageData.list"
                  ref="itemTable"
                  border
                  highlight-current-row
                  stripe
                  size="mini"
                  height="65vh"
                  v-loading="loadingdevice">
          <el-table-column type="index"
                           label="序号"
                           width="50"
                           align="center">
          </el-table-column>
          <el-table-column type="selection"
                           width="50"
                           align="center">
          </el-table-column>
          <el-table-column prop="areaName"
                           label="区域名称">
            <template slot-scope="scope">
              {{ scope.row.areaName }}
              <el-image v-for="(item, i) in showImgs(scope.row, scope.$index)"
                        :key="i"
                        style="width:20px;height:20px;margin-left:4px;position:relative;top:5px;border-radius: 4px;"
                        :src="item"
                        :preview-src-list="areaImg[scope.row.areaId + '_id']">
              </el-image>
              <el-button v-if="showVideo(scope.row, scope.$index) != null"
                         icon="el-icon-caret-right"
                         size="mini"
                         style="margin-left:4px"
                         circle
                         @click="play(scope.row.areaId)"></el-button>
            </template>
          </el-table-column>
          <el-table-column prop="assetName"
                           label="设备名称">
          </el-table-column>
          <el-table-column prop="finishTime"
                           label="完成时间">
          </el-table-column>
          <el-table-column width="120"
                           align="center"
                           prop="number"
                           label="巡检项数量">
            <template slot-scope="scope">
              <el-popover placement="left"
                          trigger="hover">
                <el-table stripe height="600"
                          :data="scope.row.list">
                  <el-table-column width="200"
                                   property="label"
                                   label="巡检项名称"></el-table-column>
                  <el-table-column width="150"
                                   property="value"
                                   label="巡检结果"></el-table-column>
                  <el-table-column width="150"
                                   property="finishTime"
                                   label="完成时间"></el-table-column>
                </el-table>
                <el-tag size="mini"
                        slot="reference">{{scope.row.number}}</el-tag>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <div class="es-page-box">
          <es-pagination :data="devicePlanPageData"
                         @change="(cpage) => { this.queryDetailObj.pageNum = cpage; this.loadDevicePlan() }">
          </es-pagination>
        </div>

      </el-form>

    </el-dialog>
    <!--计划成界面-->
    <el-dialog :visible.sync="PlanVisible"
               @closed="() => this.$refs['planForm'].clearValidate()"
               width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>计划生成
      </span>
      <el-form size="mini"
               :model="borninfo"
               :rules="bornrules"
               label-position="right"
               label-width="110px"
               ref="planForm">
        <el-form-item prop="lineIds"
                      label="线路名称">
          <el-select size="mini"
                     v-model="borninfo.lineIds"
                     placeholder="请选择线路名称"
                     clearable
                     multiple
                     filterable
                     style="width:300px">
            <el-option v-for="item in lineListOptions"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="datePlanTime"
                      label="巡检时间">
          <el-date-picker style="width:300px"
                          format="yyyy-MM-dd HH:mm"
                          v-model="borninfo.datePlanTime"
                          type="datetimerange"
                          size="small"
                          range-separator="至"
                          start-placeholder="计划开始"
                          end-placeholder="计划结束">
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item prop="planTime" label="生效日期">
          <el-date-picker value-format="yyyy-MM-dd HH:mm" style="width:200px" v-model="borninfo.planTime">
          </el-date-picker>
        </el-form-item> -->
        <!-- <el-form-item prop="starttime" label="开始时间">
          <el-date-picker format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" style="width:200px"
            v-model="borninfo.starttime">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="endtime" label="结束时间">
          <el-date-picker format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" style="width:200px"
            v-model="borninfo.endtime">
          </el-date-picker>
        </el-form-item> -->
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="PlanVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="startborn()"
                   :loading="saving">生 成</el-button>
      </span>
    </el-dialog>

    <!--巡检人员指派-->
    <el-dialog :visible.sync="PersonVisible"
               @closed="() => this.$refs['personForm'].clearValidate()"
               width="400px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>巡检人员指派
      </span>
      <el-form size="mini"
               :model="personinfo"
               :rules="personrules"
               label-position="right"
               label-width="110px"
               ref="personForm">
        <el-form-item prop="inspeople_id"
                      label="巡检人员">
          <el-select size="mini"
                     v-model="personinfo.inspeopleId"
                     placeholder="请选择线路巡检人员"
                     filterable
                     ref="selectInspeopleId"
                     style="width:200px">
            <el-option v-for="item in personList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="PersonVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="saveDistribute()"
                   :loading="peoplesaving">确 定</el-button>
      </span>
    </el-dialog>

    <!--查看详情-->
    <el-dialog :visible.sync="viewVisible"
               width="1200px"
               style="padding-top: 0px;">
      <span slot="title">
        <i class="el-icon-font el-icon-view el-icon--left"></i>故障详情
      </span>

      <el-tabs v-model="activeName"
               type="card"
               @tab-click="handleTabClick">
        <el-tab-pane label="上报信息"
                     name="first">
          <el-tabs type="card">
            <el-tab-pane label="基本信息">
              <div v-loading="viewLoading">
                <el-descriptions :column="3"
                                 style="cursor: pointer; margin-bottom: 12px"
                                 size="mini"
                                 border>
                  <el-descriptions-item label="故障单号"
                                        :labelStyle='labelStyle'
                                        v-if="faultInfo.code != '' && faultInfo.code != null">{{ faultInfo.code }}</el-descriptions-item>
                  <el-descriptions-item label="所属组织"
                                        :labelStyle='labelStyle'
                                        v-if="faultInfo.orgName != '' && faultInfo.orgName != null">{{ faultInfo.orgName }}</el-descriptions-item>
                  <el-descriptions-item label="所属区域"
                                        :labelStyle='labelStyle'
                                        v-if="
                      faultInfo.areaName != '' && faultInfo.areaName != null
                    ">{{ faultInfo.areaName }}</el-descriptions-item>
                  <el-descriptions-item label="所属系统"
                                        :labelStyle='labelStyle'
                                        v-if="
                      faultInfo.systemName != '' && faultInfo.systemName != null
                    ">{{ faultInfo.systemName }}</el-descriptions-item>
                  <el-descriptions-item label="设备类型"
                                        :labelStyle='labelStyle'
                                        v-if="
                      faultInfo.equiTypeName != '' &&
                      faultInfo.equiTypeName != null
                    ">{{ faultInfo.equiTypeName }}</el-descriptions-item>
                  <el-descriptions-item label="设备型号"
                                        :labelStyle='labelStyle'
                                        v-if="
                      faultInfo.equiModelName != '' &&
                      faultInfo.equiModelName != null
                    ">{{ faultInfo.equiModelName }}</el-descriptions-item>
                  <el-descriptions-item label="设备名称"
                                        :labelStyle='labelStyle'
                                        v-if="
                      faultInfo.equiName != '' && faultInfo.equiName != null
                    ">{{ faultInfo.equiName }}</el-descriptions-item>
                  <el-descriptions-item label="设备模块"
                                        :labelStyle='labelStyle'
                                        v-if="
                      faultInfo.equiModuleName != '' &&
                      faultInfo.equiModuleName != null
                    ">{{ faultInfo.equiModuleName }}</el-descriptions-item>
                  <el-descriptions-item label="上报时间"
                                        :labelStyle='labelStyle'
                                        v-if="
                      faultInfo.occuTime != '' && faultInfo.occuTime != null
                    ">{{ faultInfo.occuTime }}</el-descriptions-item>
                  <el-descriptions-item label="上报人"
                                        :labelStyle='labelStyle'
                                        v-if="
                      faultInfo.reporteName != '' &&
                      faultInfo.reporteName != null
                    ">{{ faultInfo.reporteName }}</el-descriptions-item>
                  <el-descriptions-item label="解决人"
                                        :labelStyle='labelStyle'
                                        v-if="
                      faultInfo.resolverName != '' &&
                      faultInfo.resolverName != null
                    ">{{ faultInfo.resolverName }}</el-descriptions-item>
                  <el-descriptions-item label="协作人"
                                        :labelStyle='labelStyle'
                                        v-if="
                      faultInfo.companionName != '' &&
                      faultInfo.companionName != null
                    ">{{ faultInfo.companionName }}</el-descriptions-item>
                  <el-descriptions-item label="规定解决时长"
                                        :labelStyle='labelStyle'
                                        v-if="
                      faultInfo.duration != '' && faultInfo.duration != null
                    ">{{ faultInfo.duration }}</el-descriptions-item>
                  <el-descriptions-item label="规定解决时间"
                                        :labelStyle='labelStyle'
                                        v-if="
                      faultInfo.planSolveTime != '' &&
                      faultInfo.planSolveTime != null
                    ">{{ faultInfo.planSolveTime }}</el-descriptions-item>
                  <el-descriptions-item label="故障等级"
                                        :labelStyle='labelStyle'
                                        v-if="
                      faultInfo.levelName != '' && faultInfo.levelName != null
                    ">{{ faultInfo.levelName }}</el-descriptions-item>
                  <el-descriptions-item label="故障现象"
                                        :labelStyle='labelStyle'
                                        v-if="
                      faultInfo.appeName != '' && faultInfo.appeName != null
                    ">{{ faultInfo.appeName }}</el-descriptions-item>
                  <el-descriptions-item label="故障描述"
                                        :labelStyle='labelStyle'
                                        v-if="faultInfo.des != '' && faultInfo.des != null">{{ faultInfo.des }}</el-descriptions-item>
                  <el-descriptions-item label="当前状态"
                                        :labelStyle='labelStyle'>
                    <div style="width: 200px">
                      <el-tag>{{ stateFormat(faultInfo, 2) }}</el-tag>
                    </div>
                  </el-descriptions-item>
                  <el-descriptions-item label="是否专工"
                                        :labelStyle='labelStyle'>
                    <div style="width: 200px">
                      <el-tag>{{ isProfFormat(faultInfo) }}</el-tag>
                    </div>
                  </el-descriptions-item>
                  <el-descriptions-item label="是否曾经激活"
                                        :labelStyle='labelStyle'>
                    <div style="width: 200px">
                      <el-tag>{{ isActivedFormat(faultInfo) }}</el-tag>
                    </div>
                  </el-descriptions-item>
                  <el-descriptions-item label="来源"
                                        :labelStyle='labelStyle'>
                    <div style="width: 200px">
                      <el-tag>{{ sourceFormat(faultInfo) }}</el-tag>
                    </div>
                  </el-descriptions-item>
                </el-descriptions>

                <es-img :info="faultInfo"
                        :fileList="fileListView"
                        type="view"></es-img>

                <!-- 扩展属性 -->
                <es-extend :extendData="extendDataReport"
                           type="view"></es-extend>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>

        <el-tab-pane label="解决信息"
                     name="second">
          <el-tabs type="card">
            <el-tab-pane label="基本信息">
              <div v-loading="viewLoading">
                <el-descriptions :column="3"
                                 style="cursor: pointer; margin-bottom: 12px"
                                 size="mini"
                                 border>
                  <el-descriptions-item label="到场时间"
                                        :labelStyle='labelStyle'
                                        v-if="
                    faultInfo.arriveTime != '' && faultInfo.arriveTime != null
                  ">{{ faultInfo.arriveTime }}</el-descriptions-item>
                  <el-descriptions-item label="解决时间"
                                        :labelStyle='labelStyle'
                                        v-if="
                    faultInfo.solveTime != '' && faultInfo.solveTime != null
                  ">{{ faultInfo.solveTime }}</el-descriptions-item>
                  <el-descriptions-item label="解决人"
                                        :labelStyle='labelStyle'
                                        v-if="
                    faultInfo.resolverName != '' &&
                    faultInfo.resolverName != null
                  ">{{ faultInfo.resolverName }}</el-descriptions-item>
                  <el-descriptions-item label="解决方法"
                                        :labelStyle='labelStyle'
                                        v-if="
                    faultInfo.solutionName != '' &&
                    faultInfo.solutionName != null
                  ">{{ faultInfo.solutionName }}</el-descriptions-item>
                  <el-descriptions-item label="解决方法描述"
                                        :labelStyle='labelStyle'
                                        v-if="
                    faultInfo.solutionDes != '' && faultInfo.solutionDes != null
                  ">{{ faultInfo.solutionDes }}</el-descriptions-item>
                  <el-descriptions-item label="解决措施"
                                        :labelStyle='labelStyle'
                                        v-if="faultInfo.measures != '' && faultInfo.measures != null">{{ faultInfo.measures }}</el-descriptions-item>
                  <el-descriptions-item label="当前状态"
                                        :labelStyle='labelStyle'>
                    <div style="width: 200px">
                      <el-tag>{{ stateFormat(faultInfo, 2) }}</el-tag>
                    </div>
                  </el-descriptions-item>
                </el-descriptions>
                <!-- 扩展属性 -->
                <es-extend :extendData="extendDataSolve"
                           type="view"></es-extend>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>

        <el-tab-pane label="材料消耗"
                     name="third">
          <el-table :data="matConsume"
                    ref="matConsumeTable"
                    show-overflow-tooltip
                    border
                    stripe
                    size="mini"
                    height="calc(70vh - 250px)"
                    v-loading="loading">
            <el-table-column type="index"
                             label="序号"
                             width="50"
                             align="center">
            </el-table-column>
            <el-table-column prop="matTypeName"
                             label="材料类型">
            </el-table-column>
            <el-table-column prop="matModelName"
                             label="材料型号">
            </el-table-column>
            <el-table-column prop="unit"
                             label="单位"> </el-table-column>
            <el-table-column prop="quantity"
                             label="数量"> </el-table-column>
            <el-table-column prop="matNumber"
                             label="材料序列号">
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="处理过程"
                     name="fourth">
          <el-row :gutter="20">
            <el-col :span="6">
              <div>&nbsp;</div>
            </el-col>
            <el-col :span="16">
              <div class="block"
                   v-loading="viewLoading">
                <el-timeline>
                  <el-timeline-item v-for="(activity, index) in activities"
                                    :key="index"
                                    :icon="activity.icon"
                                    :type="activity.type"
                                    :color="activity.color"
                                    :size="activity.size"
                                    :timestamp="activity.timestamp">
                    {{ activity.content }}
                  </el-timeline-item>
                </el-timeline>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>

    </el-dialog>
    <!--播放视频-->
    <el-dialog :visible.sync="videoVisible"
               @closed="() => { $refs['videoplay'].pause() }"
               width="900px">
      <video ref="videoplay"
             width="100%"
             height="600"
             controls
             :src="cvideo.url"></video>

      <el-tag style="margin-top:4px"> <i class="el-icon-location"></i>{{ cvideo.location }}
        &nbsp;&nbsp;&nbsp;{{ cvideo.up_time }}&nbsp;上传</el-tag>
    </el-dialog>
  </div>
</template>

<script>
import dateutils from '../../utils/dateutils.js'
export default {
  name: 'insmanage',
  props: ["funcs"],
  data () {
    return {
      //label样式
      labelStyle: { 'width': '120px' },
      orgTree: [],
      sysList: [],
      selectorgId: [],
      statesArr: [{ id: 0, name: '未开启' }, { id: 1, name: '执行中' }, { id: 2, name: '已完成' }],
      stateInspeopleArr: [{ id: 0, name: '已分配' }, { id: 1, name: '未分配' }],
      queryObj: { pageNum: 1, name: '', startday: '', endday: '', pageSize: 20, orderBy: "create_time desc" },//查询条件    
      pageData: {},
      detailVisible: false,
      lineInfo: {},//线路信息 
      dateTime: [],//时间段选择

      statesDetailArr: [{ id: 0, name: '未完成' }, { id: 1, name: '已完成' }],
      //详情信息
      queryDetailObj: { pageNum: 1, name: '', pageSize: 20 },//查询条件
      selectLine: [],
      devicePlanPageData: [], // 设备巡检计划
      loading: false,
      loadingItemResult: false,
      loadingdevice: false,
      saving: false,

      //故障详情
      viewVisible: false,
      viewLoading: false,
      fileListView: [],
      fileListViewHandle: [],
      faultInfo: [],
      activeName: 'first',
      extendDataReport: [],//上报信息的扩展信息
      extendDataSolve: [],//解決信息的扩展信息
      activities: [],//处理过程
      matConsume: [],//材料消耗
      repairInfo: {},
      activeRepairName: 'first',
      viewRepairLoading: false,
      viewRepairVisible: false,
      fileRepairListView: [],
      fileRepairHandleList: [],
      //计划生成
      PlanVisible: false,
      borninfo: {
        datePlanTime: [],
      },
      lineListOptions: [],//线路列表    

      bornrules: {//验证条件       
        lineIds: [
          { required: true, message: '请选择巡检线路', trigger: 'blur' }

        ],
        datePlanTime: [{
          type: 'array',
          required: true,
          message: '请选择日期区间',
          fields: {
            0: {
              type: 'date',
              required: true,
              trigger: "change",
              message: '请选择开始日期'
            },
            1: {
              type: 'date',
              required: true,
              trigger: "change",
              message: '请选择结束日期'
            }
          }
        }]

      },

      //巡检人员分配
      personinfo: {},
      personrules: {
        inspeopleId: [
          { required: true, message: '请选择分配的巡检人员', trigger: 'blur' }
        ]
      },
      personList: [],//管辖人员列表
      PersonVisible: false,
      peoplesaving: false,
      areaImg: {},
      areaVideo: {},
      videoVisible: false,
      cvideo: {}
    }
  },
  methods: {
    //页面初始化
    init () {
      this.loadPlanLineList()
    },

    //从后台查询线路列表
    loadPlanLineList (orgIds) {
      this.selectorgId = orgIds
      if (this.dateTime != null && this.dateTime.length > 1) {
        this.queryObj.planStartDay = this.dateFormat("YYYY-mm-dd", this.dateTime[0])
        this.queryObj.planEndDay = this.dateFormat("YYYY-mm-dd", this.dateTime[1])
      }
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(',')
      }
      this.formatQuerySate();//整理查询状态，使之适配后台
      console.log(this.queryObj)
      this.loading = true
      this.$ajax.get('/buss/insplan/getplantime', this.queryObj).then(msg => {
        this.pageData = msg

        for (var i = 0; i < this.pageData.list.length; i++) {
          var faultCode = this.pageData.list[i].faultCode
          var faultCodelist = []
          if (faultCode != null) {
            faultCodelist = faultCode.split(',')
          }
          this.$set(this.pageData.list[i], "faultCodelist", faultCodelist)
        }


        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })

    },
    formatQuerySate () {
      var nowTime = dateutils.dateFormat("YYYY-mm-dd HH:MM", new Date()) //当前时间
      delete this.queryObj.state
      delete this.queryObj.stateAdd
      if (this.queryState == 1) {//未开启
        this.queryObj.state = 0
        this.queryObj.stateAdd = "'" + nowTime + "' < plan_start_time "
      }
      if (this.queryState == 2) {//执行中
        this.queryObj.state = 0
        this.queryObj.stateAdd = "'" + nowTime + "' between plan_start_time and plan_end_time "
      }
      if (this.queryState == 3) {//已完成
        this.queryObj.state = 1
        this.queryObj.stateAdd = " done_time between plan_start_time and plan_end_time "
      }
      if (this.queryState == 4) {//逾期完成
        this.queryObj.state = 1
        this.queryObj.stateAdd = " done_time > plan_end_time "
      }
      if (this.queryState == 5) {//未完成
        this.queryObj.state = 0
        this.queryObj.stateAdd = "'" + nowTime + "' > plan_end_time "
      }
    },
    initOrgTree (orgTree) {
      this.orgTree = orgTree
    },
    viewRepair (row) {
      this.viewRepairVisible = true
      this.viewRepairLoading = true
      this.fileRepairListView = []
      this.fileRepairHandleList = []
      this.repairInfo = {}
      this.activeName = "first"
      this.$ajax.get('/buss/repair/load_detail', { id: row.id }).then((msg) => {
        //初始化图片
        if (msg.attachImgs != null && msg.attachImgs != '') {
          let temp = JSON.parse(msg.attachImgs)
          temp.forEach(e => {
            this.fileRepairListView.push(this.$api + e.url + '&platform=web&token=' + this.$store.getUser().token)
          })
        }
        //初始化图片
        if (msg.handleImgs != null && msg.handleImgs != '') {
          let temp = JSON.parse(msg.handleImgs)
          temp.forEach(e => {
            this.fileRepairHandleList.push(this.$api + e.url + '&platform=web&token=' + this.$store.getUser().token)
          })
        }
        console.log(msg);
        this.viewRepairLoading = false
        this.repairInfo = msg
      }).catch(err => {
        this.$message.error(err)
        this.viewRepairVisible = false
        this.viewRepairLoading = false
      })
    },
    //
    loadAreaTypeList () {
      this.loading = true
      this.$ajax.get('/base/areatype/list_all').then(msg => {
        this.areaTypes = msg

        this.loadingdevice = false
      }).catch(err => {
        this.$message.error(err)
        this.loadingdevice = false
      })
    },
    showState (row) {

      if (row.state == 2) {
        if (new Date(row.finishTime) > new Date(row.endtime)) {
          row.statename = "逾期完成"
          return "warning"
        }
        else {
          row.statename = "完成"
          return "success"
        }
      }
      else {

        if (new Date() > new Date(row.endtime)) {
          row.statename = "计划过期"
          return "danger"
        }
        else {
          row.statename = "未完成"
          return "primary"
        }
      }
    },

    viewFaultInfo (faultcode) {


      this.fileListView = []
      this.fileListViewHandle = []
      this.activeName = "first"
      this.$ajax.get('/buss/fault/load_detail', { code: faultcode }).then((msg) => {

        if (msg == null) {
          this.$message.error("没有找到故障数据")
          return
        }
        this.viewVisible = true
        this.viewLoading = true

        //初始化图片
        if (msg.attachImgs != null && msg.attachImgs != '') {
          let temp = JSON.parse(msg.attachImgs)
          temp.forEach(e => {
            this.fileListView.push(this.$api + e.url + '&platform=web&token=' + this.$store.getUser().token)
          })
        }
        if (msg.handleImgs != null && msg.handleImgs != '') {
          let temp = JSON.parse(msg.handleImgs)
          temp.forEach(e => {
            this.fileListViewHandle.push(this.$api + e.url + '&platform=web&token=' + this.$store.getUser().token)
          })
        }
        this.faultInfo = msg


        //加载解決扩展属性
        this.$ajax.get('/buss/fault/extend_data', {
          fauId: this.faultInfo.id, typeId: 1
        }).then((msg) => {
          this.extendDataReport = msg

        }).catch(err => {
          this.$message.error(err)
        })

        //加载解決扩展属性
        this.$ajax.get('/buss/fault/extend_data', {
          fauId: this.faultInfo.id, typeId: 2
        }).then((msg) => {
          this.extendDataSolve = msg

        }).catch(err => {
          this.$message.error(err)
        }).finally(() => {
          this.viewLoading = false
        })

      }).catch(err => {
        this.$message.error(err)
        this.viewVisible = false
        this.viewLoading = false
      })


    },

    handleTabClick (tab) {
      if (tab.name == "fourth") {
        this.viewLoading = true
        this.activities = []
        this.$ajax.get('/buss/fault/list_fau_process', { fauId: this.faultInfo.id }).then((msg) => {
          msg.forEach((ele) => {
            this.fauProcess = {}
            this.fauProcess.content = (ele.senderName == null ? '' : ele.senderName) + '【' + (ele.des == null ? '' : ele.des) + '】' + (ele.receiverName == null ? '' : ele.receiverName)
            this.fauProcess.timestamp = ele.createTime
            this.fauProcess.color = '#0bbd87'
            this.fauProcess.icon = 'el-icon-star-on'
            this.activities.push(this.fauProcess)

          })


        }).finally(() => {
          this.viewLoading = false
        }).catch(err => {
          this.$message.error(err)
          this.viewLoading = false
        })

      }

      if (tab.name == "third") {
        this.loading = true
        this.matConsume = []
        this.$ajax.get('/buss/fault/list_mat_consume', { fauId: this.faultInfo.id }).then((msg) => {

          this.matConsume = msg

        }).finally(() => {
          this.loading = false
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })

      }

    },

    //初始化设备类型下拉框
    loadTypeListAll () {
      this.$ajax.get('/base/assettype/list_all').then((msg) => {
        this.deviceTypes = msg
      }).catch(err => {
        this.$message.error(err)
      })
    },

    deleteLineplan (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      }
      else {
        this.$refs["lineTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/buss/insplan/deletelineplan', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadPlanLineList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    },
    isProfFormat (row) {
      if (row.isProf == 0) {
        return '否'
      } else {
        return '是'
      }
    },
    isActivedFormat (row) {
      if (row.isActived == 0) {
        return '否'
      } else {
        return '是'
      }
    },
    sourceFormat (row) {
      if (row.source == 1) {
        return '手机端'
      } else {
        return 'WEB端'
      }
    },
    stateFormat (row) {
      if (row.state == 1) {
        return '待分配'
      } else if (row.state == 2) {
        return '待解决'
      } else {
        return '已解决'
      }
    },

    //查看详情信息
    showDevicePlan (row) {
      this.detailVisible = true
      this.lineInfo = JSON.parse(JSON.stringify(row))
      this.loadDevicePlan()
    },

    loadDevicePlan () {
      this.queryDetailObj.planId = this.lineInfo.id
      this.$set(this.queryDetailObj, 'orderBy', "plan.area_name, plan.asset_name")
      this.loadingdevice = true
      this.$ajax.get('/buss/insplan/loadAssetPlan', this.queryDetailObj).then(msg => {
        this.devicePlanPageData = msg
        this.loadingdevice = false
      }).catch(err => {
        this.$message.error(err)
        this.loadingdevice = false
      })
    },

    deleteLinePlanValue (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      }
      else {
        this.$refs["itemTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loadingdevice = true
        this.$ajax.post('/buss/insplan/deletelineplanvalue', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryDetailObj.pageNum = 1//删除之后，回到第一页
          this.loadPlanLineList()
          this.loadDevicePlan()
        }).catch(err => {
          this.$message.error(err)
          this.loadingdevice = false
        })
      }
    },
    dateFormat (fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        }
      }
      return fmt;
    },

    //计划生成方法
    //从后台查询线路时间规则列表
    loadLineListAll () {
      this.loading = true
      this.$ajax.get('/buss/line/linelist_all').then(msg => {
        this.lineListOptions = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    createplan () {
      this.PlanVisible = true
      this.borninfo = {}
      this.datePlanTime = []
      this.loadLineListAll()
    },
    startborn () {
      this.$refs["planForm"].validate(valid => {
        if (valid) {
          var born = {}
          born.lineIds = this.borninfo.lineIds.join(',')
          born.plantime = this.dateFormat("YYYY-mm-dd", this.borninfo.datePlanTime[0])
          born.starttime = this.dateFormat("YYYY-mm-dd HH:MM", this.borninfo.datePlanTime[0])
          born.endtime = this.dateFormat("YYYY-mm-dd HH:MM", this.borninfo.datePlanTime[1])
          let url = "/buss/insplan/creatplanbylinelist";
          this.saving = true
          this.$ajax.post(url, born).then(msg => {
            this.saving = false
            this.loadPlanLineList()
            this.PlanVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //巡检人员分配
    distribute (row) {
      this.personinfo = JSON.parse(JSON.stringify(row))
      if (this.personinfo.inspeopleId != null && this.personinfo.inspeopleId != '') {
        this.personinfo.inspeopleId = Number.parseInt(this.personinfo.inspeopleId);
      }
      this.intitMasterPeople()
      this.PersonVisible = true;
    },

    intitMasterPeople () {

      var queryPeople = {}
      queryPeople.systemId = this.personinfo.sysId
      queryPeople.orgId = this.personinfo.orgId
      this.$ajax.get('/base/account/list_charge_person', queryPeople).then((msg) => {
        this.personList = msg
      }).catch(err => {
        this.$message.error(err)
      })
    },

    saveDistribute () {
      this.$refs["personForm"].validate(valid => {
        if (valid) {
          var disp = {}
          disp.id = this.personinfo.id
          disp.inspeopleId = this.personinfo.inspeopleId
          disp.inspeopleName = this.$refs.selectInspeopleId.selected.label
          let url = "/buss/insplan/savedistribute";
          this.peoplesaving = true
          this.$ajax.post(url, disp).then(msg => {
            this.peoplesaving = false
            this.loadPlanLineList()
            this.PersonVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.peoplesaving = false
          })
        }
      })
    },
    showImgs (row, i) {
      if (row.attachImgs == null) {
        return []
      } else {
        let imgs = []
        if (i == 0) {
          JSON.parse(row.attachImgs).forEach(e => {
            imgs.push(this.$api + e.url + '&platform=web&token=' + this.$store.getUser().token)
          })
        } else {
          i = i - 1
          let r = this.devicePlanPageData.list[i]
          if (r.areaId != row.areaId) {
            JSON.parse(row.attachImgs).forEach(e => {
              imgs.push(this.$api + e.url + '&platform=web&token=' + this.$store.getUser().token)
            })
          }
        }
        if (imgs.length > 0) {
          this.areaImg[row.areaId + "_id"] = imgs
        }
        return imgs
      }
    },
    showVideo (row, i) {
      let v = null
      if (row.attachVideo == null) {
        return null
      } else {
        if (i == 0) {
          v = JSON.parse(row.attachVideo)
          v.url = this.$api + v.url + '&platform=web&token=' + this.$store.getUser().token
        } else {
          i = i - 1
          let r = this.devicePlanPageData.list[i]
          if (r.areaId != row.areaId) {
            v = JSON.parse(row.attachVideo)
            v.url = this.$api + v.url + '&platform=web&token=' + this.$store.getUser().token
          }
        }
        if (v != null) {
          this.areaVideo[row.areaId + '_id'] = v
        }
        return v
      }
    },
    play (areaId) {
      this.videoVisible = true
      this.cvideo = this.areaVideo[areaId + '_id']
    }

  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped></style>
